var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash/_coreJsData.js
// module id = 403
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35